import React from 'react';
import { LogoFastship, LogoStorezigzin, LogoZdelivery } from '@croquiscom-pvt/zds';

interface Props {
  isZigzin: boolean;
  is_store_zigzin: boolean;
  isFastShipping: boolean;
  isGeneralMatchingProduct: boolean;
  hasFastShippingOption: boolean;
}

export const ShippingLogo: React.FC<React.PropsWithChildren<Props>> = ({
  isZigzin,
  is_store_zigzin,
  isFastShipping,
  isGeneralMatchingProduct,
  hasFastShippingOption,
}) => {
  if (is_store_zigzin) {
    return <LogoStorezigzin width={66} height={11} />;
  }

  if (isZigzin) {
    return <LogoZdelivery width={57} height={11} />;
  }

  const isGeneralShippingOption = !isZigzin && (isGeneralMatchingProduct || hasFastShippingOption) && !isFastShipping;

  if (isGeneralShippingOption) {
    return <>일반배송</>;
  }

  const isFastShippingOption = !isZigzin && isGeneralMatchingProduct && isFastShipping;

  if (isFastShippingOption) {
    return <LogoFastship width={62} height={11} />;
  }

  return null;
};
